/**
 * Colors for the user's channel tags. Each has a solid dot, a soft background,
 * and a deep text color of the same hue that stays readable on that background.
 * Indigo and violet are left out so tags stand apart from the brand color and
 * the upload-channel chips.
 */
const TAG_COLORS = {
  coral: { dot: '#F0643C', background: '#FFEDE6', text: '#A3381A' },
  teal: { dot: '#14A38B', background: '#E0F5F0', text: '#0D6B5B' },
  rose: { dot: '#E5487D', background: '#FDE8F0', text: '#A12054' },
  amber: { dot: '#E0A100', background: '#FFF4D6', text: '#845D00' },
  sky: { dot: '#2B8FD9', background: '#E2F1FC', text: '#165A8C' },
  leaf: { dot: '#5FA332', background: '#EAF5E0', text: '#3D6B1C' },
  plum: { dot: '#A350C2', background: '#F5E8FA', text: '#6E2C87' },
  slate: { dot: '#5E7389', background: '#E9EEF3', text: '#3A4A5B' },
};

// The suggested tags each get their own color, so they never share one.
const SUGGESTED_TAG_COLORS = {
  mitom: TAG_COLORS.coral,
  sam: TAG_COLORS.teal,
  'chi vy': TAG_COLORS.rose,
  'sister & cousin': TAG_COLORS.amber,
};

const PALETTE = Object.values(TAG_COLORS);

function hashText(text) {
  let hash = 0;
  for (const character of text) hash = (hash * 31 + character.charCodeAt(0)) >>> 0;
  return hash;
}

/**
 * The color for a tag. Other tags get a color picked from their name, so a tag
 * looks the same on every channel and every page.
 */
export function tagColor(tag) {
  const key = tag.toLowerCase();
  return SUGGESTED_TAG_COLORS[key] || PALETTE[hashText(key) % PALETTE.length];
}
